import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmVolume = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-llm-volume" data-icon="icon-llm-volume" aria-hidden="true" {...props} ref={ref}><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>);
});

IconLlmVolume.displayName = 'IconLlmVolume';
